module.exports = __webpack_public_path__ + "static/img/self.e9ef9c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/mo/zh/self.png
// module id = w5n3
// module chunks = 1 3